export default "skymp5-front/7ac223928ec8224bd850e100f191c002.gif";